export default function formatCurrencyProperly(num) {
  return Number(num).toLocaleString('en-US');
}